<template>
  <p>
    For inquiries relating to the scientific content of the conference or sponsorship possibilities,
    please contact the VIZBI chairs:
  </p>
  <Email to="vizbi-contact" :outstanding="true" />
  <p>
    For inquiries about practical matters (registration, transport, hotels, etc.), please contact
    the ASNEvents Office:
  </p>
  <p style="margin-left: 2em;">
    Jennah Henry<br /><br />
    Tel: +61 3 8658 9530<br /><br />
    9/397 Smith Street, Fitzroy, Victoria 3065 Australia
  </p>
</template>

<script setup>
import Email from "@/components/Email.vue";
</script>

<style scoped>
p:not(:first-child) {
  margin-top: 18px;
}
</style>
